export const OTHER_STATE_OPTIONS = [
    {id: "active", name: "Active"},
    {id: "inactive", name: "Inactive"}
]
